import { render, staticRenderFns } from "./JuegosProlipa.vue?vue&type=template&id=42259190"
import script from "./JuegosProlipa.vue?vue&type=script&lang=js"
export * from "./JuegosProlipa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports